import React, {useState} from 'react';
import Css from './Skills.module.css';
import {BsSuitHeartFill} from 'react-icons/bs'


export default function SkillArea() {
    let [array, setArray] = useState(["C","C++","Html","CSS","Bootstrap","JavaScript","jQuery","EJS","MongoDb","Mongoose","Node.js","Express.js","React.js", "SQL","Git & Github","Linux Command Line"]); 

    function setskills(array){
        return array.map((skill,index)=>{
           return <span className={Css.Skills} key={index+"s"}><BsSuitHeartFill color='#0e9797'/> {skill}</span>
       })
    }

  return <div id='Skills' className={Css.container}>
      <h1 className={Css.heading}>Technical Skills</h1>
        <div className={Css.skillContainer}>
            {setskills(array)}                    
        </div>
  </div>;
}

